interface ServiceSectionProps {
  id: string;
  number: string;
  title: string;
  subtitle: string;
  description: string;
  points: string[];
  imageUrl: string;
  reverse?: boolean;
  bgLight?: boolean;
}

export default function ServiceSection({
  id,
  number,
  title,
  subtitle,
  description,
  points,
  imageUrl,
  reverse = false,
  bgLight = false,
}: ServiceSectionProps) {
  return (
    <section
      id={id}
      className={`w-full py-20 ${bgLight ? 'bg-stone-50' : 'bg-white'}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className={`flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-16 items-center`}>
          {/* Image */}
          <div className="w-full lg:w-1/2 h-72 lg:h-[460px] overflow-hidden rounded-lg flex-shrink-0">
            <img
              src={imageUrl}
              alt={title}
              className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
            />
          </div>

          {/* Text */}
          <div className="w-full lg:w-1/2">
            <span className="text-amber-500 text-xs tracking-[0.5em] font-medium">{number}</span>
            <h2
              className="text-stone-900 text-2xl lg:text-3xl font-light mt-2 mb-2 leading-snug"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              {title}
            </h2>
            <p className="text-amber-700 text-sm font-medium mb-4">{subtitle}</p>
            <div className="w-10 h-px bg-amber-400 mb-6" />
            <p className="text-stone-600 text-sm leading-relaxed mb-6">{description}</p>
            <ul className="flex flex-col gap-3">
              {points.map((point) => (
                <li key={point} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-amber-600 text-sm" />
                  </div>
                  <span className="text-stone-700 text-sm">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
